
export default {
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    mode: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    // eslint-disable-next-line vue/require-default-prop
    modelValue: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Array,
      // default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    defaultActiveFirstOption: {
      type: Boolean,
      default: false,
    },
    dropdownMatchSelectWidth: {
      type: Boolean,
      default: true,
    },
    filterOption: {
      type: [Boolean, Function],
      default: undefined,
    },
  },
  data() {
    return {
      dropdownStyle: {
        zIndex: '10',
      },
    }
  },
  computed: {
    selectedValue: {
      get() {
        return this.modelValue
      },
      set(v) {
        return this.$emit('update:modelValue', v)
      },
    },
    // 如果外部没有传 filterOption prop,使用默认的过滤方法
    computedFilterOption() {
      if (this.filterOption !== undefined) {
        return this.filterOption
      }
      // 默认过滤方法
      return this.defaultFilterOption
    },
  },
  methods: {
    // 默认的过滤方法(当外部未传 filterOption 时使用)
    defaultFilterOption(inputValue, option) {
      const text = String(option?.componentOptions?.children?.[0]?.text || '');
      const keyword = String(inputValue || '');
      return text.toLowerCase().includes(keyword.toLowerCase())
    },
    handlePopupScroll(e) {
      this.$emit('popupScroll', e)
    },
    handleSearch(value) {
      this.$emit('search', value)
    },
  },
}
